import * as types from '../constants/ActionTypes';

export function getAllStatesRequest() {
  console.log('action dispatched: getAllStatesRequest')
  return {
    type: types.GET_ALL_STATES_REQUEST
  };
}


export function getAllStatesSuccess(payload) {
  console.log('action dispatched: getAllStatesSuccess', payload)
  return {
    type: types.GET_ALL_STATES_SUCCESS,
    payload
  };
}

export function getAllStatesFailure() {
  console.log('action dispatched: getAllStatesFailure')
  return {
    type: types.GET_ALL_STATES_FAILURE
  };
}





// WEBPACK FOOTER //
// ./src/store/actions/GetAllStates.js